// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --primary-color: #2196f3;
  --primary-dark: #1976d2;
  --success-color: #2ecc71;
  --warning-color: #f1c40f;
  --danger-color: #e74c3c;
  --text-primary: #2c3e50;
  --text-secondary: #7f8c8d;
  --background-light: #f8f9fa;
  --border-color: #e0e0e0;
  --shadow-sm: 0 2px 4px rgba(0,0,0,0.05);
  --shadow-md: 0 4px 6px rgba(0,0,0,0.1);
  --radius-sm: 4px;
  --radius-md: 8px;
  --radius-lg: 12px;
}

.admin-login-container {
  max-width: 400px;
  margin: 60px auto;
  padding: 32px;
  background: white;
  border-radius: var(--radius-lg);
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  animation: fadeIn 0.5s ease;
}

.admin-login-container:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 24px rgba(0, 0, 0, 0.12);
}

.admin-login-container h2 {
  color: var(--text-primary);
  margin-bottom: 24px;
  text-align: center;
  font-weight: 600;
}

.form-group {
  margin-bottom: 20px;
}

.form-group input {
  width: 100%;
  padding: 14px 18px;
  border: 2px solid var(--border-color);
  border-radius: var(--radius-sm);
  font-size: 0.95rem;
  transition: all 0.3s ease;
  background: var(--background-light);
}

.form-group input:focus {
  outline: none;
  border-color: var(--primary-color);
  box-shadow: 0 0 0 3px rgba(33, 150, 243, 0.15);
  transform: translateY(-1px);
}

.error-message {
  background-color: rgba(231, 76, 60, 0.15);
  color: #c0392b;
  padding: 12px;
  border-radius: var(--radius-sm);
  margin-bottom: 20px;
  font-size: 0.9rem;
  text-align: center;
}

button[type="submit"] {
  width: 100%;
  padding: 14px 24px;
  background: linear-gradient(45deg, var(--primary-dark), var(--primary-color));
  color: white;
  border: none;
  border-radius: var(--radius-md);
  font-weight: 600;
  font-size: 0.95rem;
  letter-spacing: 0.3px;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  margin-top: 8px;
}

button[type="submit"]:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(33, 150, 243, 0.25);
}

.back-to-login {
  width: 100%;
  padding: 12px 20px;
  background: transparent;
  color: var(--text-secondary);
  border: 2px solid var(--border-color);
  border-radius: var(--radius-md);
  font-weight: 500;
  font-size: 0.95rem;
  cursor: pointer;
  transition: all 0.3s ease;
  margin-top: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.back-to-login:hover {
  background: var(--background-light);
  color: var(--text-primary);
  border-color: var(--text-secondary);
  transform: translateY(-1px);
  box-shadow: var(--shadow-sm);
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@media (max-width: 768px) {
  .admin-login-container {
    margin: 40px 20px;
    padding: 24px;
  }
} `, "",{"version":3,"sources":["webpack://./src/components/AdminLogin.css"],"names":[],"mappings":"AAAA;EACE,wBAAwB;EACxB,uBAAuB;EACvB,wBAAwB;EACxB,wBAAwB;EACxB,uBAAuB;EACvB,uBAAuB;EACvB,yBAAyB;EACzB,2BAA2B;EAC3B,uBAAuB;EACvB,uCAAuC;EACvC,sCAAsC;EACtC,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,iBAAiB;EACjB,+BAA+B;EAC/B,0CAA0C;EAC1C,qDAAqD;EACrD,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,qCAAqC;EACrC,+BAA+B;EAC/B,kBAAkB;EAClB,yBAAyB;EACzB,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,kCAAkC;EAClC,8CAA8C;EAC9C,2BAA2B;AAC7B;;AAEA;EACE,yCAAyC;EACzC,cAAc;EACd,aAAa;EACb,+BAA+B;EAC/B,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,6EAA6E;EAC7E,YAAY;EACZ,YAAY;EACZ,+BAA+B;EAC/B,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,eAAe;EACf,iDAAiD;EACjD,eAAe;AACjB;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,uBAAuB;EACvB,4BAA4B;EAC5B,qCAAqC;EACrC,+BAA+B;EAC/B,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,mCAAmC;EACnC,0BAA0B;EAC1B,mCAAmC;EACnC,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,iBAAiB;IACjB,aAAa;EACf;AACF","sourcesContent":[":root {\n  --primary-color: #2196f3;\n  --primary-dark: #1976d2;\n  --success-color: #2ecc71;\n  --warning-color: #f1c40f;\n  --danger-color: #e74c3c;\n  --text-primary: #2c3e50;\n  --text-secondary: #7f8c8d;\n  --background-light: #f8f9fa;\n  --border-color: #e0e0e0;\n  --shadow-sm: 0 2px 4px rgba(0,0,0,0.05);\n  --shadow-md: 0 4px 6px rgba(0,0,0,0.1);\n  --radius-sm: 4px;\n  --radius-md: 8px;\n  --radius-lg: 12px;\n}\n\n.admin-login-container {\n  max-width: 400px;\n  margin: 60px auto;\n  padding: 32px;\n  background: white;\n  border-radius: var(--radius-lg);\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);\n  transition: transform 0.3s ease, box-shadow 0.3s ease;\n  animation: fadeIn 0.5s ease;\n}\n\n.admin-login-container:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 6px 24px rgba(0, 0, 0, 0.12);\n}\n\n.admin-login-container h2 {\n  color: var(--text-primary);\n  margin-bottom: 24px;\n  text-align: center;\n  font-weight: 600;\n}\n\n.form-group {\n  margin-bottom: 20px;\n}\n\n.form-group input {\n  width: 100%;\n  padding: 14px 18px;\n  border: 2px solid var(--border-color);\n  border-radius: var(--radius-sm);\n  font-size: 0.95rem;\n  transition: all 0.3s ease;\n  background: var(--background-light);\n}\n\n.form-group input:focus {\n  outline: none;\n  border-color: var(--primary-color);\n  box-shadow: 0 0 0 3px rgba(33, 150, 243, 0.15);\n  transform: translateY(-1px);\n}\n\n.error-message {\n  background-color: rgba(231, 76, 60, 0.15);\n  color: #c0392b;\n  padding: 12px;\n  border-radius: var(--radius-sm);\n  margin-bottom: 20px;\n  font-size: 0.9rem;\n  text-align: center;\n}\n\nbutton[type=\"submit\"] {\n  width: 100%;\n  padding: 14px 24px;\n  background: linear-gradient(45deg, var(--primary-dark), var(--primary-color));\n  color: white;\n  border: none;\n  border-radius: var(--radius-md);\n  font-weight: 600;\n  font-size: 0.95rem;\n  letter-spacing: 0.3px;\n  cursor: pointer;\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  margin-top: 8px;\n}\n\nbutton[type=\"submit\"]:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(33, 150, 243, 0.25);\n}\n\n.back-to-login {\n  width: 100%;\n  padding: 12px 20px;\n  background: transparent;\n  color: var(--text-secondary);\n  border: 2px solid var(--border-color);\n  border-radius: var(--radius-md);\n  font-weight: 500;\n  font-size: 0.95rem;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  margin-top: 16px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n}\n\n.back-to-login:hover {\n  background: var(--background-light);\n  color: var(--text-primary);\n  border-color: var(--text-secondary);\n  transform: translateY(-1px);\n  box-shadow: var(--shadow-sm);\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(20px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n@media (max-width: 768px) {\n  .admin-login-container {\n    margin: 40px 20px;\n    padding: 24px;\n  }\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
